<template>
	<div id="app">
		<NavPc v-if="isPc && !is3d"></NavPc>
		<router-view />
		<!-- <NavBottomPc v-if="isPc && !is3d" v-show="isShowFooter"></NavBottomPc> -->
		<TabBar v-if="!isPc && !is3d" v-show="isShowFooter" />
	</div>
</template>
<script>
	import request from "@/utils/request";
	import TabBar from "@/components/TabBar.vue";
	import NavPc from "@/components/nav_pc.vue";
	import NavM from "@/components/nav_m.vue";
	import NavBottomPc from "@/components/nav_bottom_pc.vue";
	import {
		mapState
	} from "vuex";
	import store from "./store";
	export default {
		data() {
			return {
				windowWidth: document.body.clientWidth,
				wsRetryCount: 0, // WebSocket重连计数
				// 不显示底部白名单
			};
		},
		components: {
			NavPc,
			NavM,
			NavBottomPc,
			TabBar
		},
	mounted() {
		//console.log('🚀 App.vue mounted开始');

		// 初始化设备类型判断（结合User Agent和窗口大小）
		this.updateDeviceType();
		
		// 设置初始窗口宽度
		store.commit("SetInnerWidth", document.body.clientWidth);
		
		// ✅ 获取系统时区配置（无需登录，尽早获取）
		this.fetchSystemTimezone();
		
		// 🎨 优先加载缓存的主题色（避免闪烁），然后从后台更新
		this.applyStoredThemeColor();
		this.initThemeColor();

		//console.log('📱 设备检测结果:', {
		// 	userAgent: navigator.userAgent,
		// 	isMobileDevice: this.isPc,
		// 	windowWidth: window.innerWidth
		// });

	// ✅ 窗口大小改变时只更新窗口宽度，不切换设备类型
	// 设备类型只在页面加载时判断一次（通过User Agent）
	window.onresize = () => {
		return (() => {
			this.windowWidth = document.documentElement.clientWidth; // 宽
			store.commit("SetInnerWidth", this.windowWidth);
			// ❌ 注释掉：不再根据窗口大小切换设备类型
			// this.updateDeviceType();
		})();
	};
			// 在页面加载时和窗口大小变化时调用设置字体大小的函数
			window.addEventListener('DOMContentLoaded', this.setRootFontSize);
			window.addEventListener('resize', this.setRootFontSize);
			// 设置默认语言
			let lang = localStorage.getItem("lang") || this.$store.state.currentLanguage;
			this.$store.commit("SET_LANG", lang);
			this.$store.dispatch("listContents", lang == 'zh' ? 1 : 2).then((res) => {
				// // //console.log(res, "language");
			});
			// 设置是否虚拟账户
			// // //console.log(localStorage.getItem("virtualStatus"));
			let isVirtual = localStorage.getItem("virtualStatus") || 1;
		this.$store.commit("changeVirtual", isVirtual);
		// ws - 延迟建立连接，确保组件已准备好
		setTimeout(() => {
			try {
				this.$store.dispatch("GET_WS_MARKET").then((res) => {
					// WebSocket连接成功
				}).catch((err) => {
					console.error("WebSocket 连接失败:", err);
					// 如果连接失败，尝试重连
					setTimeout(() => {
						this.retryWebSocketConnection();
					}, 5000);
				});
			} catch (error) {
				console.error("WebSocket 初始化异常:", error);
			}
		}, 1000); // 延迟1秒建立连接
			let isLogin = localStorage.getItem("isLogin");
			if (isLogin) {
				this.$store.dispatch("GET_USER_INFO").then((res) => {
					// //console.log(res, "user");
				});
			}


			// 判断当前是手机还是pc
		},
	watch: {
		// 监听页面宽度
		windowWidth(val) {
			// //console.log(val, "width");
			// store.commit('SetInnerWidth', val)
		},
		// 监听黑夜模式切换
		'$store.state.darkMode'(newVal) {
			// 重新应用主题颜色
			this.initThemeColor();
		}
	},
		computed: {
			...mapState(["footerWhiteList", "isPc", "lginWhiteList"]),
			currentRouteName() {
				return this.$route.name;
			},
			is3d() {
				return this.lginWhiteList.indexOf(this.currentRouteName) > -1;
			},
			isShowFooter() {
				// 检查路由 meta 中的 hideTabBar
				if (this.$route.meta && this.$route.meta.hideTabBar) {
					return false;
				}
				return this.footerWhiteList.indexOf(this.currentRouteName) == -1;
			}
		},
	methods: {
		// 🎨 从localStorage快速加载缓存的主题色（避免绿色闪烁）
		applyStoredThemeColor() {
			const isDarkMode = this.$store.state.darkMode;
			const cachedColorLight = localStorage.getItem('themeColorLight');
			const cachedColorDark = localStorage.getItem('themeColorDark');
			
			// 如果有缓存，立即应用（避免显示默认绿色）
			if (cachedColorLight || cachedColorDark) {
				const themeColor = isDarkMode ? 
					(cachedColorDark || '#0156DC') : 
					(cachedColorLight || '#0156DC');
				
				const root = document.documentElement;
				const rgb = this.hexToRgb(themeColor);
				const darkerColor = this.getDarkerColor(themeColor, 20);
				const lighterColor = this.getLighterColor(themeColor, 20);
				
				// 立即应用主题色
				root.style.setProperty('--primary-color', themeColor);
				root.style.setProperty('--primary-light', lighterColor);
				root.style.setProperty('--primary-dark', darkerColor);
				root.style.setProperty('--primary-rgb', rgb);
				root.style.setProperty('--primary-color-5', `rgba(${rgb}, 0.05)`);
				root.style.setProperty('--primary-color-8', `rgba(${rgb}, 0.08)`);
				root.style.setProperty('--primary-color-10', `rgba(${rgb}, 0.1)`);
				root.style.setProperty('--primary-color-15', `rgba(${rgb}, 0.15)`);
				root.style.setProperty('--primary-color-18', `rgba(${rgb}, 0.18)`);
				root.style.setProperty('--primary-color-20', `rgba(${rgb}, 0.2)`);
			}
		},
		
		// 🎨 颜色工具函数
		hexToRgb(hex) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : '1, 86, 220';
		},
		
		getDarkerColor(hex, percent = 20) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			if (!result) return '#0146B0';
			
			const r = Math.max(0, parseInt(result[1], 16) - Math.round(parseInt(result[1], 16) * percent / 100));
			const g = Math.max(0, parseInt(result[2], 16) - Math.round(parseInt(result[2], 16) * percent / 100));
			const b = Math.max(0, parseInt(result[3], 16) - Math.round(parseInt(result[3], 16) * percent / 100));
			
			return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
		},
		
		getLighterColor(hex, percent = 20) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			if (!result) return '#3478E6';
			
			const r = Math.min(255, parseInt(result[1], 16) + Math.round((255 - parseInt(result[1], 16)) * percent / 100));
			const g = Math.min(255, parseInt(result[2], 16) + Math.round((255 - parseInt(result[2], 16)) * percent / 100));
			const b = Math.min(255, parseInt(result[3], 16) + Math.round((255 - parseInt(result[3], 16)) * percent / 100));
			
			return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
		},
		
		// ✅ 获取系统时区配置（无需登录）
		async fetchSystemTimezone() {
			try {
				// 优先从缓存读取
				const cachedTimezone = localStorage.getItem('systemTimezone');
				if (cachedTimezone) {
					try {
					const timezone = JSON.parse(cachedTimezone);
					this.$store.commit('setSystemTimezone', timezone);
					} catch (e) {
						console.warn('缓存的时区数据解析失败:', e);
					}
				}
				
				// 从后端获取最新的时区配置
				await this.$store.dispatch('FETCH_SYSTEM_TIMEZONE').then(timezone => {
					if (timezone) {
					// 保存到缓存
					localStorage.setItem('systemTimezone', JSON.stringify(timezone));
					}
				});
			} catch (error) {
				console.error('❌ 获取系统时区失败:', error);
				// 失败时使用默认值，不影响其他功能
			}
		},
		
		// 🎨 初始化主题颜色
		async initThemeColor() {
			const isDarkMode = this.$store.state.darkMode;
			
			try {
				// 从后台加载主题颜色配置
				const response = await this.$http.get('/swx/settings/customerService');
				
				if (response && response.code === 200 && response.result) {
					const config = response.result;
					const root = document.documentElement;
					
					// 应用主题色
					const themeColor = isDarkMode ? 
						(config.themeColorDark || '#0156DC') : 
						(config.themeColorLight || '#0156DC');
					
					// 💾 保存到 localStorage（供下次刷新快速加载）
					if (config.themeColorLight) {
						localStorage.setItem('themeColorLight', config.themeColorLight);
					}
					if (config.themeColorDark) {
						localStorage.setItem('themeColorDark', config.themeColorDark);
					}
					
					// 计算派生颜色
					const rgb = this.hexToRgb(themeColor);
					const darkerColor = this.getDarkerColor(themeColor, 20);
					const lighterColor = this.getLighterColor(themeColor, 20);
					
					// 应用主题色及派生色
					root.style.setProperty('--primary-color', themeColor);
					root.style.setProperty('--primary-light', lighterColor);
					root.style.setProperty('--primary-dark', darkerColor);
					root.style.setProperty('--primary-rgb', rgb);
					
					// 应用透明度变量
					root.style.setProperty('--primary-color-5', `rgba(${rgb}, 0.05)`);
					root.style.setProperty('--primary-color-8', `rgba(${rgb}, 0.08)`);
					root.style.setProperty('--primary-color-10', `rgba(${rgb}, 0.1)`);
					root.style.setProperty('--primary-color-15', `rgba(${rgb}, 0.15)`);
					root.style.setProperty('--primary-color-18', `rgba(${rgb}, 0.18)`);
					root.style.setProperty('--primary-color-20', `rgba(${rgb}, 0.2)`);
					
					// 如果是黑夜模式，应用背景色和文本色
					if (isDarkMode) {
						if (config.darkBgPrimary) {
							root.style.setProperty('--bg-primary-custom', config.darkBgPrimary);
						}
						if (config.darkBgSecondary) {
							root.style.setProperty('--bg-secondary-custom', config.darkBgSecondary);
						}
						if (config.darkTextPrimary) {
							root.style.setProperty('--text-primary-custom', config.darkTextPrimary);
						}
						if (config.darkTextSecondary) {
							root.style.setProperty('--text-secondary-custom', config.darkTextSecondary);
						}
						if (config.darkBorderColor) {
							root.style.setProperty('--border-color-custom', config.darkBorderColor);
						}
					}
				}
			} catch (error) {
				console.error('❌ 主题颜色初始化失败:', error);
			}
		},
		
		// WebSocket重连方法
		retryWebSocketConnection() {
			try {
				this.$store.dispatch("GET_WS_MARKET").then((res) => {
					this.wsRetryCount = 0; // 重置重试计数
				}).catch((err) => {
					console.error("WebSocket 重连失败:", err);
					// 如果还是失败，再次尝试重连（最多重试3次）
					if (!this.wsRetryCount) this.wsRetryCount = 0;
					if (this.wsRetryCount < 3) {
						this.wsRetryCount++;
						setTimeout(() => {
							this.retryWebSocketConnection();
						}, 10000); // 10秒后重试
					} else {
						console.error("WebSocket 重连失败超过3次，停止重连");
					}
				});
			} catch (error) {
				console.error("WebSocket 重连异常:", error);
			}
			},

	isMobileDevice() {
		// 基于 User Agent 检测设备类型（不依赖窗口大小）
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		
		// 检测各种移动设备
		const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
		const isMobile = mobileRegex.test(userAgent);
		
		// 检测平板设备（部分平板可能需要当作 PC 处理）
		const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);
		
		// 返回是否为 PC（非移动设备且非平板，或者是平板但屏幕足够大）
		// 这里我们把平板当作 PC 处理
		const isPc = !(isMobile && !isTablet);
		return isPc;
	},
		
	// ✅ 更新设备类型判断（只根据User Agent判断设备类型）
	updateDeviceType() {
		// 只使用User Agent判断，不考虑窗口大小
	const isPcByUserAgent = this.isMobileDevice();
	
	// ✅ 只根据设备类型（User Agent）判断，不考虑窗口宽度
	// 这样PC端缩小窗口也不会切换到移动端模式
	const isPcDevice = isPcByUserAgent;
	
	// 注释掉原来的窗口宽度检查逻辑
	// const windowWidth = window.innerWidth || document.documentElement.clientWidth;
	// const isPcByWidth = windowWidth > 768;
	// const isPcDevice = isPcByUserAgent && isPcByWidth;
		
		// 记录之前的设备类型
		const previousIsPc = this.$store.state.isPc;
		
		// 更新store（如果设备类型改变）
		if (previousIsPc !== isPcDevice) {
			store.commit("SET_IS_PC", isPcDevice);
			
			// 根据设备类型初始化夜间模式
			const storageKey = isPcDevice ? 'darkMode_pc' : 'darkMode_mobile';
			const darkMode = localStorage.getItem(storageKey) === 'true';
			store.commit("setDarkMode", darkMode);
		}
		
		// 根据设备类型检查并跳转路由（包括首次加载和设备切换）
		this.handleDeviceRouteChange(isPcDevice, previousIsPc);
	},
	
	// 处理设备切换时的路由跳转
	handleDeviceRouteChange(isPcDevice, previousIsPc) {
		const currentPath = this.$route.path;
		
		// 检查是否需要跳转
		const shouldRedirect = 
			(isPcDevice && currentPath !== '/') || // PC端且不在首页
			(!isPcDevice && previousIsPc !== isPcDevice); // 从PC切换到手机端
		
		if (!shouldRedirect) {
			return;
		}
		
		if (isPcDevice) {
			// PC端：不管访问什么路径都跳到首页
			this.$router.push('/').catch(err => {
				if (err.name !== 'NavigationDuplicated') {
					console.error('路由跳转错误:', err);
				}
			});
		} else {
			// 手机端：从PC切换过来时跳转到市场页面
			if (currentPath !== '/market') {
				this.$router.push('/market').catch(err => {
					if (err.name !== 'NavigationDuplicated') {
						console.error('路由跳转错误:', err);
					}
				});
			}
		}
	},

			setRootFontSize() {
				// //console.log(111);
				let baseWidth = 1920;
				if (window.innerWidth > 1000) {
					baseWidth = 1920;
				} else {
					baseWidth = 750;
				}
				const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				let scale = 1;
				if (baseWidth == 750) {
					scale = (screenWidth / baseWidth) + .37;
				} else {
					// scale=(screenWidth/baseWidth) + .2;
					scale = (screenWidth / baseWidth) + 1;
				}
				// //console.log(scale, 'scale');
				const maxRemSize = 100;
				const rootFontSize = Math.min(maxRemSize, 100 * scale);
				// //console.log(rootFontSize, 'rootFontSize');
				document.documentElement.style.fontSize = rootFontSize + 'px';
			}
		},
	};
</script>
<style>
	@import "reset.css";

	/* @media screen and (min-width: 1000px) {
  #app {
    width: 1440px;
    margin: 0 auto;
  }
} */
	body {
		font-size: 0.16rem;
	}

	img,
	video {
		max-width: 100%;
		height: auto;
	}

	.button {
		cursor: pointer;
		padding: 0 .36rem;
		height: 100%;
		border-radius: .2rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 700;
		font-size: .2rem;
		color: #000;
		-webkit-tap-highlight-color: transparent
	}

	.button .icon {
		margin-right: .12rem;
		width: .24rem;
		height: .24rem
	}

	#app {
		margin: 0 auto;
		width: 100%;
		/* max-width: 14.4rem; */
		font-family: Mabry Pro;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		font-size: .16rem;
		overflow-x: hidden;
		height: 100vh;
	}

	.input_fields .el-input .el-input__wrapper {
		box-shadow: none;
		background: none;
	}

	.button.round {
		border-radius: .32rem
	}

	.button.normal {
		background: #e8e8e8
	}

	.button.yellow {
		background: linear-gradient(180deg, #ffdc61, #ffbc49)
	}

	.button.black {
		background: #000;
		color: #fff
	}

	.button.line {
		background: #fff;
		border: .02rem solid #000;
		box-sizing: border-box
	}

	.button.disabled {
		background: #dfdfdf;
		color: #8a8a8a
	}

	/* Narrow logout confirm dialog */
	.logout-confirm .el-message-box {
		width: 360px !important;
		max-width: 90vw !important;
		min-width: 0 !important;
	}
</style>